import type { TopologyGraphPreset } from '@ipfabric/utils';
import { setPresetDraftState } from 'components/Graph/helpers/setPresetDraftState';
import type { GraphCommandFactory } from 'components/Graph/model/GraphCommandContext';

export const resetTopologyPreset: GraphCommandFactory =
  (cmdContext) => async () => {
    try {
      const { presetDraft } = cmdContext.getState().layoutSettings;
      cmdContext.updateState(setPresetDraftState('resetting'));
      const presets: TopologyGraphPreset[] = await cmdContext.api.request({
        url: '/graphs/presets',
        method: 'GET',
      });
      const foundPresetIndex = presets.findIndex(
        (preset) => preset.id === presetDraft.id,
      );
      if (foundPresetIndex > -1) {
        cmdContext.updateState((draft) => {
          // Fixed noUncheckedIndexedAccess NIM-19408
          draft.layoutSettings.presets[foundPresetIndex] =
            presets[foundPresetIndex]!;
          // Fixed noUncheckedIndexedAccess NIM-19408
          draft.layoutSettings.presetDraft = presets[foundPresetIndex]!;
        });
      }
    } finally {
      cmdContext.updateState(setPresetDraftState('idle'));
    }
  };
